"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StripCard_st_css_1 = require("./StripCard.st.css");
var deprecationLog_1 = require("../../common/deprecationLog");
exports.MIN_WIDTH = 700;
var StripCard = /** @class */ (function (_super) {
    __extends(StripCard, _super);
    function StripCard(props) {
        var _this = _super.call(this, props) || this;
        deprecationLog_1.wrap('Card');
        return _this;
    }
    StripCard.prototype.componentDidMount = function () {
        deprecationLog_1.deprecationLog('StripCard', 'The current `Card` component API will be deprecated in the next major version. Please use the `upgrade` prop in order to use the new API.\nYou can view the new API here: https://wix-wix-ui-tpa.surge.sh/?path=/story/components--newcard');
        deprecationLog_1.unwrap('Card');
    };
    StripCard.prototype.render = function () {
        var _a = this.props, media = _a.media, info = _a.info, roundMedia = _a.roundMedia, sidePadding = _a.sidePadding, rest = __rest(_a, ["media", "info", "roundMedia", "sidePadding"]);
        return (React.createElement("div", __assign({}, StripCard_st_css_1.default('root', { roundMedia: roundMedia, sidePadding: sidePadding }, rest)),
            media ? React.createElement("div", { className: StripCard_st_css_1.default.mediaContainer }, media) : null,
            info ? React.createElement("div", { className: StripCard_st_css_1.default.infoContainer }, info) : null));
    };
    StripCard.displayName = 'StripCard';
    StripCard.MIN_WIDTH = 700;
    StripCard.defaultProps = {
        roundMedia: false,
        sidePadding: true,
    };
    return StripCard;
}(React.Component));
exports.StripCard = StripCard;
//# sourceMappingURL=StripCard.js.map